import useCms from './cms/useCms'
import type { SbglobalConfig } from '~/cms/storyblok/types/storyblok'

export default () => {
  const config = useRuntimeConfig()
  const { fetchBySlug, fetching, data } = useCms<SbglobalConfig>('globalConfig')
  const globalConfig = computed<SbglobalConfig>(
    () => data.value?.content as any,
  )

  const load = async () => {
    if (fetching.value || globalConfig.value) {
      return
    }

    // Try loading from configSet path first, fallback to default path
    const configPath = config.public.configSet || '/configuration/global-config'
    await fetchBySlug(configPath)

    // If configSet path failed, try default path
    if (!data.value && configPath !== '/configuration/global-config') {
      await fetchBySlug('/configuration/global-config')
    }
  }

  return {
    config: globalConfig,

    blackFridayLabels: computed(() => globalConfig.value?.blackFridayLabels),
    backInStock: computed(() => globalConfig.value?.backInStockFeature),
    runKameleoon: computed(() => globalConfig.value?.runKameleoon),
    idKameleoon: computed(() => globalConfig.value?.idKameleoon),
    pathKameleoon: computed(() => globalConfig.value?.pathKameleoon),
    htfFeatures: computed(() => globalConfig.value?.htfFeatures),
    isGoldnerAnniversary: computed(() => globalConfig.value?.goldner100Years),
    cancellationFormUrl: computed(
      () => globalConfig.value?.orderCancellationFormUrl,
    ),

    fetch: load,
  }
}
